import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function SvgComponent(props) {
  return (
    <Svg
      x="0px"
      y="0px"
      viewBox="0 0 508.8 508.8"
      xmlSpace="preserve"
      enableBackground="new 0 0 508.8 508.8"
      {...props}
    >
      <Path d="M258.448 96L211.52 60.8 258.448 25.6 239.248 0 158.176 60.8 239.248 121.6z" />
      <Path d="M331.232 468.144l9.344 30.592a232.201 232.201 0 0032-12.432l-13.76-28.8a201.491 201.491 0 01-27.584 10.64zM272.848 476.8v32c11.448-.005 22.88-.84 34.208-2.496L302.4 474.64a202.69 202.69 0 01-29.552 2.16zM465.368 147.256C422.247 83.191 350.074 44.781 272.848 44.8v32c110.457-.018 200.014 89.511 200.032 199.968.011 66.58-33.112 128.8-88.352 165.968l17.92 26.528c106.295-71.545 134.465-215.713 62.92-322.008z" />
      <Path d="M123.728 131.024L3.872 413.376l210.096 89.2 119.856-282.352-210.096-89.2zm73.296 329.6l-151.2-64.16 94.848-223.472 151.2 64.16-94.848 223.472z" />
    </Svg>
  );
}

export default SvgComponent;
